import React, { useLayoutEffect } from "react";
import { useTheme } from "@material-ui/core";
import clsx from "clsx";
import { useDeviceTypes } from "halifax";
import { RouteComponentProps } from "react-router-dom";
import { ExperimentStateWithCallState, TripsModuleProps } from "redmond";
import {
  isCorpTenant,
  isCaponeTenant,
  isVesperTenant,
  useUserContext,
} from "@capone/common";

import { PAWTUCKET_TRIPS_MODULE_ID } from "../../utils/moduleIds";
import useMicrofrontend from "../../hooks/useMicrofrontend";
import config from "../../utils/config";
import { colors as caponeColors } from "../../utils/capone/colors";
import { colors as corpColors } from "../../utils/capone-corporate/colors";
import "./styles.scss";

interface ITripsModuleProps extends RouteComponentProps {
  experiments?: ExperimentStateWithCallState;
  language: string;
  showCoreHomepage?: boolean;
}

const TripsModule = (props: ITripsModuleProps) => {
  const { experiments, language, showCoreHomepage, ...routerProps } = props;
  const { history } = routerProps;
  const id = PAWTUCKET_TRIPS_MODULE_ID;
  const theme = useTheme();
  const { matchesDesktop, matchesSmallDesktop, matchesMobile } =
    useDeviceTypes();
  const { isLoaded, ptTripsModule } = useMicrofrontend(
    id,
    (config.ptTripsModuleUrl += "")
  );
  const { sessionInfo, logo, isBusinessEligible, isMultiportal } =
    useUserContext(config.TENANT);
  const isVesper = isVesperTenant(config.TENANT);

  useLayoutEffect(() => {
    if (!ptTripsModule) return;
    const { render, unMount } = ptTripsModule;
    const tripModuleProps: TripsModuleProps & {
      showCoreHomepage?: boolean;
    } = {
      experiments,
      theme,
      isAgentPortal: config.ptIsAgentPortal,
      language: language,
      showCoreHomepage,
      colors: isCorpTenant(config.TENANT) ? corpColors : caponeColors,
      baseHistory: history,
      clientAssets: {
        logo: <img src={logo?.src} alt={logo?.alt} />,
        sessionInfo,
        isConsumerMultiPortal: isCaponeTenant(config.TENANT)
          ? isBusinessEligible
          : isMultiportal,
      },
    };

    render(id, tripModuleProps);
    return () => {
      unMount(id);
    };
  }, [isLoaded]); // eslint-disable-line

  if (!isLoaded) return null;
  if (!ptTripsModule) return <h2>ERROR! Cannot find Module</h2>;
  return (
    <div
      className={clsx(
        "trips-module-container",
        {
          desktop: matchesDesktop || matchesSmallDesktop,
          redesigned: isVesper,
          mobile: matchesMobile,
        }
      )}
      id={id}
    />
  );
};

export default TripsModule;
